export enum WoundType {
  DECUBITUS = 'DECUBITUS',
  ULCUSCRURISVEN = 'ULCUSCRURISVEN',
  ULCUSCRURISDIABET = 'ULCUSCRURISDIABET',
  FOOTSYNDROM = 'FOOTSYNDROM',
  OTHER = 'OTHER',
}
